import { render, staticRenderFns } from "./PostsFilter.vue?vue&type=template&id=57dcd33e&scoped=true&"
import script from "./PostsFilter.vue?vue&type=script&lang=js&"
export * from "./PostsFilter.vue?vue&type=script&lang=js&"
import style0 from "./PostsFilter.vue?vue&type=style&index=0&id=57dcd33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dcd33e",
  null
  
)

export default component.exports